import { Component, OnInit, Input, Optional } from '@angular/core';
import { ModalController, IonToggle } from '@ionic/angular';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { CuentaComponent } from '../cuenta/cuenta.component';
import { PrivacidadComponent } from '../privacidad/privacidad.component';
import { SeguridadComponent } from '../seguridad/seguridad.component';
import { PublicacionesColeccionComponent } from 'src/app/components/publication/create/publicaciones-coleccion/publicaciones-coleccion/publicaciones-coleccion.component';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { ViewChild } from '@angular/core';
import Swal2 from 'sweetalert2';
import { RequestService } from 'src/app/services/request/request.service';
import { Utils } from 'src/app/Models/Classes/utils';
import { NativeTapToPay } from 'src/app/plugins/native-runtime.plugins';
import { TapToPayBrandingService } from 'src/app/services/wallet/tap-to-pay-branding.service';
@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss'],
})
export class ConfiguracionComponent implements OnInit {
@Input() profile_id: any;
@ViewChild('Lia_toggleElement') Lia_toggleElement: IonToggle;
  public tapToPayIsIphone = Capacitor.getPlatform() === 'ios';
  public tapToPayAvailableOnThisDevice = this.tapToPayIsIphone;
  public tapToPayAvailabilityMessage = '';
  public tapToPayLinked: boolean | null = null;
  public tapToPayEducationOpen = false;
  public tapToPaySettingsBusy = false;
  public tapToPaySymbolSrc = 'assets/icon/tap-to-pay.svg';
  private readonly tapToPayConnectionTokenEndpoint = 'https://supercluster-api.laniakea.tv/api/stripe/terminal/connection-token';
  constructor(
    private modalController: ModalController,
    private formService:FormServiceService,
    private request: RequestService,
    @Optional() private utils?: Utils,
    @Optional() private router?: Router,
    @Optional() private tapToPayBranding?: TapToPayBrandingService,
  ) { }

  ngOnInit() {
    console.log('config pr', this.profile_id);
    if (this.tapToPayIsIphone) {
      void this.loadTapToPaySettings();
    }
  }

  private async loadTapToPaySettings(): Promise<void> {
    if (this.tapToPayBranding) {
      this.tapToPaySymbolSrc = await this.tapToPayBranding.getSymbolImage();
    }

    try {
      const availability = await NativeTapToPay.isAvailable();
      if (!availability?.available) {
        this.tapToPayAvailableOnThisDevice = false;
        this.tapToPayAvailabilityMessage = availability?.reason || 'Tap to Pay is not available on this iPhone.';
        return;
      }

      // `getAccountStatus` is available only after the native Terminal
      // instance has been configured. Configure it here as well as in
      // Payment Preferences so Settings can show the real existing-user
      // state without opening checkout or Apple's setup sheet.
      if (!this.utils) {
        return;
      }

      const configResponse = this.parseTapToPayResponse(
        await this.request.createRequestPost('stripe/terminal/config', {})
      );
      const accessData: any = await this.utils.getAccessData();
      const authorization = accessData?.getAuthorization?.();
      if (!configResponse?.location_id || !authorization) {
        return;
      }

      await NativeTapToPay.configure({
        connectionTokenEndpoint: this.tapToPayConnectionTokenEndpoint,
        authorization,
        locationId: configResponse.location_id,
      });

      const account = await NativeTapToPay.getAccountStatus();
      this.tapToPayLinked = account?.linked === true;
    } catch (error) {
      // Keep the entry visible for an older installed binary. The payment
      // preferences screen will show the precise native setup error there.
      console.warn('[Tap to Pay] Could not check Settings availability.', error);
    }
  }

  private parseTapToPayResponse(response: any): any {
    let value = response;

    for (let attempt = 0; attempt < 3 && typeof value === 'string'; attempt += 1) {
      try {
        value = JSON.parse(value);
      } catch (_) {
        return {};
      }
    }

    if (value && typeof value === 'object' && typeof value.body === 'string') {
      const body = this.parseTapToPayResponse(value.body);
      return body && typeof body === 'object' ? { ...value, ...body } : value;
    }

    return value && typeof value === 'object' ? value : {};
  }

  public async openTapToPayMerchantEducation(): Promise<void> {
    try {
      const result = await NativeTapToPay.showMerchantEducation();
      if (result?.presented) {
        return;
      }
    } catch (error) {
      // The official education sheet is available on iOS 18+. Keep a plain
      // fallback for older installed binaries rather than using imitation
      // card-placement artwork.
      console.warn('[Tap to Pay] Native merchant education unavailable.', error);
    }
    this.tapToPayEducationOpen = !this.tapToPayEducationOpen;
  }

  public async tryTapToPayFromSettings(): Promise<void> {
    if (this.tapToPayLinked !== true) {
      return;
    }

    await this.openTapToPayPaymentPreferences();
  }

  public async openTapToPayPaymentPreferences(): Promise<void> {
    if (this.tapToPaySettingsBusy) {
      return;
    }

    this.tapToPaySettingsBusy = true;
    try {
      await this.modalController.dismiss({ dismissed: true });
    } catch (_) {
      // The Settings component can also be presented outside a modal.
    }

    try {
      if (this.router) {
        await this.router.navigate(['/home/ecosystem-page/wallet'], {
          queryParams: {
            section: 'Payment Pref.',
            payment_method: 'tap_to_pay',
            source: 'tap_to_pay_settings',
          },
        });
      }
    } finally {
      this.tapToPaySettingsBusy = false;
    }
  }
  ngAfterViewInit(){
    this.Lia_toggleElement.checked = this.formService.heyLia;
  }
  selectLanguage(event: any) {
    const selectedLang = event.detail.value;
    console.log('Selected language:', selectedLang);
    console.log('Selected language:', this.formService.selectedLiaLanguage);
    this.request.createRequestPost('handle_hey_Lia', {update:true, language: selectedLang})
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		console.log(data);
		
		if(data.success){
		
			Swal2.fire({
        title: 'Lia modificada',
        text: 'Lia se ha actualizado exitosamente.',
        icon: 'success',
        timer: 4500, // Show the alert for 45 seconds
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
       // position: 'top-end',
        showConfirmButton: false
        });
			
		}
		})
		.catch((error) => {
		
		  console.error('An error occurred:', error);
		  // Handle the error here, such as displaying a message to the user or logging it for further investigation.
		});
    // Implement your logic to handle the selected language
    // For example, you might want to save it to the database or update the UI
  }
  cambio($event){
    console.log($event);
		this.request.createRequestPost('handle_hey_Lia', {update:true, hey_lia: this.formService.heyLia})
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		console.log(data);
		
		if(data.success){
		
			Swal2.fire({
        title: 'Lia modificada',
        text: 'Oye Lia se ha actualizado exitosamente.',
        icon: 'success',
        timer: 4500, // Show the alert for 45 seconds
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        showConfirmButton: false
        });
			
		}
		})
		.catch((error) => {
		
		  console.error('An error occurred:', error);
		  // Handle the error here, such as displaying a message to the user or logging it for further investigation.
		});
  }
  InfoUser(App:String){
    switch(App ){
      case "Privacidad":
      this.modalController.create({
        component: PrivacidadComponent,
        cssClass: 'detailsInModal',
        canDismiss: true, // (forced globally for swipe close on all modals)
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      break;
      case "Seguridad":
        this.modalController.create({
          component: SeguridadComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
        }).then((modal) => {
          modal.present();
        }).catch((error) => {
          console.error(error);
        });
        break;
        case "Cuenta":
          this.modalController.create({
            component:CuentaComponent,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
          }).then((modal) => {
            modal.present();
          }).catch((error) => {
            console.error(error);
          });
          break;
        case "Regalos":
        this.formService.sectionVer="regalos"  
        this.modalController.create({
          component:PublicacionesColeccionComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            profile_id: this.profile_id,
          }
        }).then((modal) => {
          modal.present();
        }).catch((error) => {
          console.error(error);
        });
        break;

    }
  }
  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
